export interface StreamUser {
  id: number;
  name: string;
  email: string;
  prenom: string;
  nom: string;
  scene_name: string;
  profile_picture: string;
  rang: string;
  status: string;
}

export interface StreamSettings {
  video: boolean;
  audio: boolean;
}

export interface ChatSettings {
  enabled: boolean;
  moderators_only: boolean;
}

export interface Stream {
  id: number;
  user_id: string;
  title: string;
  slug: string;
  description: string;
  status: string;
  is_public: boolean;
  stream_key: string;
  viewer_count: string;
  viewers_count: string;
  peak_viewer_count: string;
  stream_settings: StreamSettings;
  chat_settings: ChatSettings;
  scheduled_start_time: string | null;
  started_at: string;
  ended_at: string | null;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
  thumbnail_url: string | null;
  user: StreamUser;
  /** 1 = gratuit, 0 = payant */
  free?: number;
  /** Prix (pour live payant) */
  price?: number;
  /** Nombre de signalements (admin / withCount stream_reports) */
  stream_reports_count?: number;
}

/** Signalement de live (stream_reports) */
export interface StreamReport {
  id: number;
  stream_id: number;
  reporter_id: number;
  reason: string;
  details: string | null;
  created_at: string;
  updated_at: string;
  reporter?: Partial<StreamUser>;
}

/** true si le live est payant (free === 0) */
export function isStreamPaid(stream: Stream | Record<string, unknown>): boolean {
  const free = stream?.free;
  const price = stream?.price;
  return Number(free) === 0 && Number(price ?? 0) > 0;
} 